module.exports = __webpack_public_path__ + "static/media/bronze.60a11b9b.svg";